// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod/mini'

export const zApiResponseError = z.object({
	code: z.readonly(
		z.enum([
			'unauthorized',
			'expired_token',
			'user_not_active',
			'access_denied',
			'system_error',
			'route_not_found',
			'service_offline',
			'not_found',
			'invalid_input',
			'access_restrict',
			'limit_avance',
			'conflict',
			'no_utm_access',
		]),
	),
	details: z.optional(z.readonly(z.array(z.string()))),
	ip: z.optional(z.readonly(z.ipv4())),
	location: z.optional(z.readonly(z.string())),
	message: z.readonly(z.string()),
	status_code: z.readonly(z.int().check(z.gte(0), z.lte(999))),
})

export const zCustomerCabinetBalance = z.object({
	balance: z._default(z.optional(z.readonly(z.string().check(z.regex(/^[-+]?\d+\.\d{2}$/)))), '0.00'),
	credit: z._default(z.optional(z.readonly(z.string().check(z.regex(/^\+?\d+\.\d{2}$/)))), '0.00'),
	state: z.optional(z.readonly(z.union([z.literal(0), z.literal(1), z.literal(2)]))),
})

export const zCustomerTariffLimits = z.object({
	down: z.readonly(z.string()),
	up: z.readonly(z.string()),
})

export const zCustomerCabinetService = z.object({
	additional: z._default(z.optional(z.readonly(z.boolean())), false),
	cost: z._default(z.optional(z.readonly(z.string().check(z.regex(/^\+?\d+\.\d{2}$/)))), '0.00'),
	expire: z.optional(z.readonly(z.iso.datetime())),
	id: z.readonly(z.int().check(z.gte(1), z.maximum(2_147_483_647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))),
	name: z.readonly(z.string()),
	service_id: z.readonly(z.int().check(z.gte(1), z.maximum(2_147_483_647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))),
	speed: z.optional(z.readonly(zCustomerTariffLimits)),
	start: z.optional(z.readonly(z.iso.datetime())),
})

export const zCustomerCabinetServicesResponse = z.object({
	services: z.readonly(z.array(zCustomerCabinetService)),
	total_cost: z._default(z.optional(z.readonly(z.string().check(z.regex(/^\+?\d+\.\d{2}$/)))), '0.00'),
})

export const zLoginCabinetRequest = z.object({
	login: z.string().check(z.regex(/^[\w.@-]{1,15}$/)),
	password: z.string().check(z.regex(/^[\w,.!@-]{3,20}$/)),
})

export const zLoginCabinetResponse = z.object({
	flat: z.optional(z.readonly(z.string())),
	location: z.readonly(z.string()),
	login: z.readonly(z.string().check(z.regex(/^[\w.@-]{1,15}$/))),
	mobile_phone: z.optional(z.readonly(z.string().check(z.regex(/^\+380(50|66|95|99|75|67|68|96|97|98|63|73|93|77)\d{7}$/)))),
	pib: z.readonly(z.string()),
	uid: z.readonly(z.int().check(z.gte(1), z.maximum(2_147_483_647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))),
})

export const zBalanceResponse = z.readonly(zCustomerCabinetBalance)

export const zCustomerResponse = z.readonly(zLoginCabinetResponse)

export const zLoginBody = zLoginCabinetRequest

export const zLoginResponse = z.readonly(zLoginCabinetResponse)

export const zServicesResponse = z.readonly(zCustomerCabinetServicesResponse)
